import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import ExitingPersistence from '@atlaskit/motion/exiting-persistence';
import FadeIn from '@atlaskit/motion/fade-in';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Text } from '@atlaskit/primitives/compiled/text';

import { messages } from '../../messages.ts';
import { ManualBulkCreateLoadingImage } from '../../assets/ManualBulkCreateLoadingImage.tsx';

const loadingMessages = [
	messages.manualBulkCreateLoadingTextFirst,
	messages.manualBulkCreateLoadingTextSecond,
	messages.manualBulkCreateLoadingTextThird,
];

export const BulkCreateManualLoading = (): React.JSX.Element => {
	const [loadingMessageIndex, setLoadingMessageIndex] = useState(0);

	useEffect(() => {
		// Creates a 1.5 second interval between rotating the three text options contained in loadingMessages
		const intervalId = window.setInterval(() => {
			setLoadingMessageIndex((prev) => (prev + 1) % loadingMessages.length);
		}, 1500);

		return () => window.clearInterval(intervalId);
	}, []);

	return (
		<>
			<ManualBulkCreateLoadingImage />
			<ExitingPersistence exitThenEnter>
				<FadeIn entranceDirection="right" duration="large">
					{(motionProps) => (
						<Box {...motionProps}>
							<Text>
								<FormattedMessage {...loadingMessages[loadingMessageIndex]} />
							</Text>
						</Box>
					)}
				</FadeIn>
			</ExitingPersistence>
		</>
	);
};
